export function normalizePath(input: string | undefined | null): string {
  const raw = String(input ?? "").trim();
  return raw ? raw.replace(/^\/+/, "").replace(/\/+$/, "") : "";
}

export function resolvePathnameLike(input: string | undefined | null): string {
  const raw = String(input ?? "").trim();
  if (!raw) return "/";

  if (typeof window === "undefined") {
    return raw.startsWith("/") ? raw : `/${raw}`;
  }

  try {
    return new URL(raw, window.location.href).pathname;
  } catch {
    return raw.startsWith("/") ? raw : `/${raw}`;
  }
}

/** Extract the query suffix from a path-like navigation target. */
export function extractSearch(input: string | undefined | null): string {
  const raw = String(input ?? "").trim();
  if (!raw) return "";
  try {
    const url = new URL(
      raw,
      typeof window !== "undefined" ? window.location.href : "http://localhost",
    );
    return url.search || "";
  } catch {
    const queryIndex = raw.indexOf("?");
    return queryIndex >= 0 ? raw.slice(queryIndex) : "";
  }
}

/** Repeated search keys resolve to their final value. */
export function parseSearchParams(
  search: string | undefined | null,
): Record<string, string> {
  const raw = String(search ?? "").trim();
  if (!raw) return {};
  try {
    const params = new URLSearchParams(raw);
    const out: Record<string, string> = {};
    for (const [key, value] of params.entries()) {
      if (key) out[key] = value;
    }
    return out;
  } catch {
    return {};
  }
}